export const formatDate = (dateString) => {
  const date = new Date(dateString);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let getDate = day + "-" + month + "-" + year;
  return getDate;
};
export const formatDate2 = (dateString) => {
  const date = new Date(dateString);
  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();
  let getDate = year + "-" + month + "-" + day;
  return getDate;
};

export const getuser = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user;
};
